"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitter = void 0;
var _react = _interopRequireDefault(require("react"));
var Twitter = exports.Twitter = function Twitter() {
  return _react["default"].createElement("svg", {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("rect", {
    width: "36",
    height: "36",
    rx: "2",
    fill: "#1DA1F2"
  }), _react["default"].createElement("path", {
    d: "M12.8622 28C22.2966 28 27.456 20.3062 27.456 13.6345C27.456 13.4159 27.4514 13.1984 27.4415 12.9818C28.443 12.2691 29.3134 11.3798 30 10.3674C29.081 10.7695 28.092 11.0402 27.0545 11.1622C28.1134 10.5372 28.9264 9.54837 29.31 8.36963C28.319 8.94794 27.2215 9.36826 26.053 9.59519C25.117 8.61382 23.7845 8 22.309 8C19.4765 8 17.1795 10.2611 17.1795 13.0483C17.1795 13.4445 17.2245 13.8298 17.3125 14.1995C13.0496 13.9884 9.26953 11.9793 6.7397 8.92431C6.29921 9.67045 6.04521 10.5372 6.04521 11.462C6.04521 13.2137 6.95073 14.7601 8.32773 15.6647C7.48621 15.6391 6.6957 15.4117 6.00477 15.0332C6.00402 15.0544 6.00401 15.0751 6.00401 15.0977C6.00401 17.5429 7.77203 19.5844 10.119 20.047C9.68797 20.1627 9.23451 20.2247 8.76648 20.2247C8.43648 20.2247 8.11497 20.1928 7.80248 20.1337C8.45547 22.1398 10.349 23.5996 12.5939 23.6404C10.8384 24.9949 8.62697 25.8016 6.22348 25.8016C5.80998 25.8016 5.40148 25.7785 5 25.7317C7.27002 27.164 9.96545 27.9997 12.8625 27.9997",
    fill: "white"
  }));
};